export enum OrderWorkflowActionType {
  EMAIL = "EMAIL",
  PREP_TICKET = "PREP_TICKET",
  UPDATE_ETA = "UPDATE_ETA",
}
